module.exports = __webpack_public_path__ + "img/94840.360db120.svg";